import React, { useState, useEffect } from 'react';
import FoodMenuService from '../Services/QRCodeServices/CustomerService/FoodMenuService';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Loading from '../QRCodeCustomerPanel/Loading/Loading';

const PAGE_CSS_MAP = {
  '': 'theme.css',
  'home': 'theme.css',
  'about': 'about.css',
  'contact': 'contact.css',
  'food-menu': 'foodMenu.css',
  'drinks-menu': 'foodMenu.css',
  'checkout': 'checkout.css'
};

const STYLESHEET_IDS = [
  'all-theme',
  'tenant-theme',
  'tenant-page-style',
  'tenant-header-style',
  'tenant-footer-style'
];

const TenantStylesLoader = ({ apiResponse }) => {
  const location = useLocation();

  useEffect(() => {
    if (!apiResponse?.theme?.title) return;

    const cleanupStylesheets = () => {
      STYLESHEET_IDS.forEach(id => {
        const existingLink = document.getElementById(id);
        existingLink?.remove();
      });
    };

    const getPageSpecificCSS = () => {
      const pathSegments = location.pathname.split('/').filter(Boolean);
      const lastSegment = pathSegments.length > 1
        ? pathSegments[pathSegments.length - 1]
        : 'home';

      return PAGE_CSS_MAP[lastSegment] || 'theme.css';
    };

    const loadStylesheet = (id, href) => {
      if (!document.getElementById(id)) {
        const link = document.createElement('link');
        link.id = id;
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    };

    const loadStylesheets = () => {
      const { title } = apiResponse.theme;
      console.log("title",title)
      const pageCSS = getPageSpecificCSS();

      loadStylesheet('all-theme', `/tenants/themes/allTheme.css`);
      loadStylesheet('tenant-common', `/tenants/themes/${title}/common.css`);
      loadStylesheet('tenant-theme', `/tenants/themes/${title}/${pageCSS}`);
      loadStylesheet('tenant-header-style', `/tenants/themes/${title}/header.css`);
      loadStylesheet('tenant-footer-style', `/tenants/themes/${title}/bottom.css`);
    };

    cleanupStylesheets();
    loadStylesheets();

    return cleanupStylesheets;
  }, [apiResponse, location.pathname]);

  // No rendering needed if everything works correctly
  return null;
};

export default TenantStylesLoader;



// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import FoodMenuService from "../Services/QRCodeServices/CustomerService/FoodMenuService";
// import { useParams } from "react-router-dom";

// const TenantStylesLoader = () => {
//   const { orgCode, pageName } = useParams(); // Extract route params from the URL
//   const [data, setData] = useState({});
//   console.log("🚀 ~ TenantStylesLoader ~ data:", data)
//   const location = useLocation();

//   const themeName = data?.theme?.title || "Theme1"; // Default to 'theme1' if theme is not available
//   console.log("🚀 ~ TenantStylesLoader ~ themeName:", themeName)

//   const routeStyleMap = {
//     home: "home",    // "home" maps to "theme"
//     about: "about",
//     contact: "contact",
//   };

//   // Get the style file name based on the route
//   const getRouteStyleFile = () => {
//     const routeName = routeStyleMap[pageName] || "home";
//     return routeName;
//   };
//   console.log("🚀 ~ getRouteStyleFile ~ getRouteStyleFile:", getRouteStyleFile)

//   // Fetch theme data
//   const fetchTheme = async () => {
//     try {
//       const response = await FoodMenuService.getFoodMenu(orgCode);
//       console.log("🚀 ~ fetchTheme ~ response:", response)
//       setData(response);
//     } catch (error) {
//       console.error("Error fetching theme:", error);
//     }
//   };

//   // Fetch theme whenever orgCode changes
//   useEffect(() => {
//     fetchTheme();
//   }, [orgCode]);

//   // Dynamically load CSS file whenever path, orgCode, or theme changes
//   useEffect(() => {
//     const existingThemeLink = document.getElementById("tenant-theme");
//     if (existingThemeLink) {
//       existingThemeLink.remove();
//     }

//     const themeFile = `${getRouteStyleFile()}.css`;
//     const link = document.createElement("link");
//     console.log("🚀 ~ useEffect ~ themeFile:", themeFile)
//     link.id = "tenant-theme";
//     link.rel = "stylesheet";
//     link.href = `/tenants/themes/${themeName}/${themeFile}?v=${Date.now()}`; // Add cache-buster
//     document.head.appendChild(link);
//     console.log("🚀 ~ useEffect ~ link:", link)

//     // Cleanup: remove the link on component unmount or on dependency change
//     return () => {
//       const existingLink = document.getElementById("tenant-theme");
//       if (existingLink) {
//         existingLink.remove();
//       }
//     };
//   }, [location.pathname, orgCode, themeName]);

//   return null;
// };

// export default TenantStylesLoader;
